import React from "react";
import { Link } from "react-router-dom";

function Landing() {
  return (
    <div className="mx-auto">
      <div className="bg-white border p-4 m-5">
        <h6>Are you a traveller or a patient?</h6>
        <p className="card-text">
          Choose traveller to enter the algorithm for triage in ports of entry.
          Choose patient to enter the algorithm for triage in healthcare
          facilities.
        </p>
        <Link to="/traveller" className="card-link btn btn-primary">
          Traveller
        </Link>
        <Link to="/patient" className="card-link btn btn-primary">
          Patient
        </Link>
      </div>
    </div>
  );
}

export default Landing;
